module.exports = __webpack_public_path__ + "static/media/MF2_0124_copie.d36f5194.webp";